<template>
    <!-- выбор языка, как на aeroflot.ru: кнопка с флагом и кодом, по клику справа выезжает панель. dark — на тёмной шапке -->
    <button type="button" @click="open = true" :aria-label="t('chooseLanguage')"
        class="flex items-center gap-1.5 px-2 sm:px-2.5 py-1.5 rounded-lg text-[14px]/[17px] font-medium uppercase transition-colors"
        :class="dark ? 'text-white hover:bg-white/10' : 'bg-[#F4F5F6] hover:bg-[#EEF1F6]'">
        <!-- на узких экранах без флага, иначе кнопка упирается в логотип -->
        <img :src="`/${locale}.png`" alt="" class="hidden sm:block w-6 h-6 object-contain">
        {{ locale }}
        <Icon name="heroicons:chevron-down-20-solid" size="16" class="hidden sm:block opacity-70" />
    </button>

    <USlideover v-model="open" :ui="{ width: 'w-screen max-w-sm', overlay: { background: 'bg-black/40' } }">
        <div class="p-6">
            <div class="flex items-center justify-between mb-4">
                <h2 class="text-[24px]/[29px] font-bold">{{ t('chooseLanguage') }}</h2>
                <button type="button" @click="open = false" :aria-label="t('close')"
                    class="p-2 rounded-lg bg-[#F4F5F6] hover:bg-[#EEF1F6] transition-colors">
                    <Icon name="heroicons:x-mark" size="20" class="block" />
                </button>
            </div>
            <ul>
                <li v-for="l in locales" :key="l.code" class="border-b border-gray-line">
                    <NuxtLink :to="switchLocalePath(l.code)" @click="open = false"
                        class="flex items-center gap-3 py-4 hover:text-my-green transition-colors">
                        <img :src="`/${l.code}.png`" alt="" class="w-7 h-7 object-contain">
                        <span class="text-[16px]/[19px]">{{ l.name }}</span>
                        <Icon v-if="l.code === locale" name="heroicons:check" size="22" class="ml-auto text-my-green" />
                    </NuxtLink>
                </li>
            </ul>
        </div>
    </USlideover>
</template>

<script setup>
const { locale, locales, t } = useI18n()
const switchLocalePath = useSwitchLocalePath()
defineProps({
    dark: { type: Boolean, default: false },
})
const open = ref(false)
</script>
